<template>
  <div class="container main-content clearfix services home">
    {{ $t('etc_funda_1') }}
    <h3 class="title">{{ $t('etc_funda_2') }}</h3>
    {{ $t('etc_funda_3') }}
    <h4>{{ $t('etc_funda_4') }}</h4>

    <p v-html="$t('etc_funda_5')">
    </p>
    <p v-html="$t('etc_funda_6')">
    </p>
    <p v-html="$t('etc_funda_7')">
    </p>
    <p v-html="$t('etc_funda_8')">
    </p>
    <p v-html="$t('etc_funda_9')">
    </p>

    <h4>{{ $t('etc_funda_10') }}</h4>
    {{ $t('etc_funda_11') }}

    <h3 class="title">{{ $t('etc_funda_12') }}</h3>
    {{ $t('etc_funda_13') }}

    <h4>{{ $t('etc_funda_14') }}</h4>
    <p v-html="$t('etc_funda_15')">
    </p>

    <h4>{{ $t('etc_funda_10') }}</h4>
    {{ $t('etc_funda_16') }}
  </div>
</template>

<script>
export default {
  name: 'FundaChecker',
  mounted () {
    document.title = 'Funda bookmarklets by Narabi Systems'
  },
  destroyed () {
    document.title = 'Narabi Systems'
  }
}
</script>

<style>
  a.bookmarklet {
    border: 1px outset #ddd;
    padding: 1px;
    vertical-align: 1px;
    background: #ddd;
    text-decoration: none;
    font-family: sans-serif;
    font-size: 110%;
    color: #FF9900;
  }
</style>
